export default {
	props: {
		blockId: {
			type: String,
			default: ''
		},
	},
}